@if (isActive && !isSelf) {
  <div
    class="main-panel border border-dark p-3 rounded-3 position-relative overflow-hidden"
    [ngClass]="{
      'opacity-50': selectedMFAOption && selectedMFAOption.id === 'EMAIL_OTP',
    }"
    data-test="mfa-configurator"
  >
    @if (loading) {
      <div
        class="position-absolute top-0 start-0 left-0 bottom-0 end-0 d-flex align-items-center justify-content-center"
        style="background-color: rgba(0, 0, 0, 0.85); z-index: 10"
      >
        <div
          class="spinner-border text-primary"
          style="width: 75px; height: 75px"
          role="status"
        >
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    }
    <!-- button to reset users MFA back to email -->
    @if (!hasMFAConfigured) {
      <div class="alert alert-info mb-3" role="alert">
        <mat-icon class="me-2">info</mat-icon>
        This user does not currently have MFA configured. Email verification will be used by default.
      </div>
    }
    @if (hasMFAConfigured && selectedMFAOption && selectedMFAOption.id !== 'EMAIL_OTP') {
      <p>
        If this user is having issues logging in with their current MFA method
        <b>{{ selectedMFAOption.title }}</b>, it can be reset here and will
        default back to an email verification.
      </p>
    }
    @if (hasMFAConfigured && selectedMFAOption && selectedMFAOption.id === 'EMAIL_OTP') {
      <p>
        This user is currently using <b>{{ selectedMFAOption.title }}</b> verification. No reset is needed.
      </p>
    }
    <button
      [disabled]="!hasMFAConfigured || (selectedMFAOption && selectedMFAOption.id === 'EMAIL_OTP')"
      data-test="reset-mfa"
      mat-flat-button
      class="mt-2 d-block ms-0 me-auto bg-white-always mon-border-success border mon-text-success flex-shrink-0"
      (click)="ResetIndividualsMFA()"
    >
      {{
        !hasMFAConfigured ? 'Unavailable' :
        selectedMFAOption && selectedMFAOption.id === 'EMAIL_OTP'
          ? 'Unavailable'
          : 'Reset MFA'
      }}
    </button>
  </div>
}

@if (isActive && isSelf) {
  <div
    class="main-panel border border-dark p-3 rounded-3 position-relative overflow-hidden"
    style="min-height: 200px"
    data-test="mfa-configurator"
  >
    @if (loading) {
      <div
        class="position-absolute top-0 start-0 left-0 bottom-0 end-0 d-flex align-items-center justify-content-center"
        style="background-color: rgba(0, 0, 0, 0.85); z-index: 10"
      >
        <div
          class="spinner-border text-primary"
          style="width: 75px; height: 75px"
          role="status"
        >
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    }
    <div class="container-fluid">
      @if (step === 'SELECT_METHOD') {
        <ng-container [ngTemplateOutlet]="select_method"></ng-container>
      }
      @if (step === 'ENTER_SMS') {
        <ng-container [ngTemplateOutlet]="enter_sms"></ng-container>
      }
      @if (step === 'VALIDATE_SMS') {
        <ng-container [ngTemplateOutlet]="validate_sms"></ng-container>
      }
      @if (step === 'SETUP_TOTP') {
        <ng-container [ngTemplateOutlet]="setup_totp"></ng-container>
      }
      @if (step === 'VERIFY_TOTP') {
        <ng-container [ngTemplateOutlet]="verify_totp"></ng-container>
      }
    </div>
  </div>
}

<ng-template #select_method>
  <div class="row mb-3">
    <p class="my-0 fs-5">Multi-factor Authentication</p>
  </div>
  @if (options.length > 0 && selectedMFAOption !== undefined) {
    <div class="row">
      @for (option of options; track option.id) {
        <div class="col-12 col-md-6 px-1">
          <button
            class="mb-2 w-100 d-flex border border-3 align-items-stretch justify-content-start bg-light rounded-3 p-2"
            (click)="selectMFAOption(option)"
            [disabled]="selectedMFAOption.id === option.id"
            [ngClass]="{
              'border-primary': selectedMFAOption.id === option.id,
              'border-light': selectedMFAOption.id !== option.id,
            }"
            [attr.data-test]="
              (option.id === 'TOTP' ? 'mfa-method-mobile-app' :
              option.id === 'SMS_MFA' ? 'mfa-method-sms' :
              option.id === 'EMAIL_OTP' ? 'mfa-method-email' : null)
                + (selectedMFAOption.id === option.id ? '-selected' : '-not-selected')
            "
          >
            <div
              class="d-flex align-items-center justify-content-center rounded-circle overflow-hidden mon-bg-primary"
              style="width: 45px; height: 45px"
            >
              <mat-icon class="fs-2 d-block" style="width: auto; height: auto">{{
                option.icon
              }}</mat-icon>
            </div>
            <div
              class="ms-2 flex-fill d-flex flex-column justify-content-start align-items-start"
            >
              <p class="fs-6 text-dark my-0">{{ option.title }}</p>
              <p class="small text-start lh-sm text-muted my-0">
                {{ option.description }}
              </p>
            </div>
            <div
              class="ms-2 d-flex align-items-center justify-content-center rounded-circle overflow-hidden"
              style="width: 45px; height: 45px"
            >
              <mat-icon
                class="fs-4 d-block text-dark outline"
                style="width: auto; height: auto"
                >{{ option.selected ? 'check_circle' : 'circle' }}
              </mat-icon>
            </div>
          </button>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #enter_sms>
  @if (profileSettings) {
    <div>
      <p>In order to continue, we need to verify your phone number</p>
      <mat-form-field
        class="d-block w-100"
        data-test="mfa-form-sms"
        appearance="outline"
      >
        <mat-label>Phone Number</mat-label>
        <input
          matInput
          [(ngModel)]="profileSettings.phoneNumber"
          placeholder="Phone Number"
          data-test="mfa-input-sms"
        />
      </mat-form-field>

      <div class="d-flex justify-content-between align-items-center mt-2">
        <button
          mat-flat-button
          (click)="resetForm()"
          class="d-block bg-white-always mon-border-danger border mon-text-danger flex-shrink-0"
          data-test="mfa-back-sms"
        >
          Back
        </button>
        <button
          mat-flat-button
          (click)="ConfigurePhoneNumber()"
          class="mt-2 d-block ms-auto me-0 bg-white-always mon-border-success border mon-text-success flex-shrink-0"
          data-test="mfa-continue-sms"
        >
          Continue
        </button>
      </div>
    </div>
  }
</ng-template>

<ng-template #validate_sms>
  @if (smsValidationResponse) {
    <div>
      <p>
        Please enter the code sent to your device:
        {{ smsValidationResponse.smsDestination }}
      </p>
      <mat-form-field
        class="d-block w-100"
        data-test="mfa-validate-form-sms"
        appearance="outline"
      >
        <mat-label>One-Time Code</mat-label>
        <input
          matInput
          [(ngModel)]="smsValidationResponse.otp"
          placeholder="One-Time Code"
          data-test="mfa-validate-input-sms"
        />
      </mat-form-field>

      <div class="d-flex justify-content-between align-items-center mt-2">
        <button
          data-test="mfa-validate-back-sms"
          mat-flat-button
          (click)="resetForm()"
          class="d-block bg-white-always mon-border-danger border mon-text-danger flex-shrink-0"
        >
          Back
        </button>
        <button
          data-test="mfa-validate-continue-sms"
          mat-flat-button
          (click)="VerifyPhoneNumber()"
          class="mt-2 d-block ms-auto me-0 bg-white-always mon-border-success border mon-text-success flex-shrink-0"
        >
          Complete
        </button>
      </div>
    </div>
  }
</ng-template>

<ng-template #setup_totp>
  @if (totpSecret) {
    <div class="text-center">
      <p class="my-0">Scan the QR code with your chosen authenticator app</p>
      <qr-code value="{{ totpSecret }}" errorCorrectionKLevel="M" data-test="mfa-setup-qr-totp"></qr-code>
      <p class="small text-muted">
        We recommend Google Authenticator, available on the app store and play
        store.
      </p>
      <div class="d-flex justify-content-between align-items-center mt-2">
        <button
          mat-flat-button
          (click)="resetForm()"
          class="d-block bg-white-always mon-border-danger border mon-text-danger flex-shrink-0"
          data-test="mfa-setup-back-totp"
        >
          Back
        </button>
        <button
          mat-flat-button
          (click)="step = 'VERIFY_TOTP'"
          class="mt-2 d-block ms-auto me-0 bg-white-always mon-border-success border mon-text-success flex-shrink-0"
          data-test="mfa-setup-continue-totp"
        >
          Continue
        </button>
      </div>
    </div>
  }
</ng-template>

<ng-template #verify_totp>
  <div>
    <p>Please enter the code from your device</p>
    <mat-form-field
      class="d-block w-100"
      data-test="mfa-verify-form-totp"
      appearance="outline"
    >
      <mat-label>One-Time Code</mat-label>
      <input 
      matInput 
      [(ngModel)]="totpCode" 
      placeholder="One-Time Code"
      data-test="mfa-verify-input-totp"
      />
    </mat-form-field>

    <div class="d-flex justify-content-between align-items-center mt-2">
      <button
        data-test="mfa-verify-back-totp"
        mat-flat-button
        (click)="resetForm()"
        class="d-block bg-white-always mon-border-danger border mon-text-danger flex-shrink-0"
      >
        Back
      </button>
      <button
        data-test="mfa-verify-complete-totp"
        mat-flat-button
        (click)="VerifyTOTPCode()"
        class="mt-2 d-block ms-auto me-0 bg-white-always mon-border-success border mon-text-success flex-shrink-0"
      >
        Complete
      </button>
    </div>
  </div>
</ng-template>
